// Keep the cookie match in sync with apps/api/src/auth/native-session-redirect.ts.
const SESSION_COOKIE_NAME =
  /^(?:__Secure-|__Host-)?couplespace(?:-(?:dev|prod|test))?\.session_token$/;

const AUTH_PROTOCOLS = new Set(['couplespace:', 'couplespacedev:']);

export function sessionTokenFromSetCookie(setCookie: string | null | undefined): string | null {
  if (!setCookie) return null;
  const parts = setCookie.split(/,(?=\s*[^;,\s]+=)/);
  for (const part of parts) {
    const trimmed = part.trim();
    const separator = trimmed.indexOf('=');
    if (separator <= 0) continue;
    const name = trimmed.slice(0, separator).trim();
    if (!SESSION_COOKIE_NAME.test(name)) continue;
    if (/;\s*Max-Age=0(?:\s*;|\s*$)/i.test(trimmed)) continue;
    const value = (trimmed.slice(separator + 1).split(';')[0] ?? '').trim();
    if (!value) continue;
    return value;
  }
  return null;
}

function parseAuthCallback(url: string): URL | null {
  try {
    const parsed = new URL(url);
    if (!AUTH_PROTOCOLS.has(parsed.protocol)) return null;
    if (parsed.hostname !== 'auth') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function isNativeAuthCallback(url: string): boolean {
  return parseAuthCallback(url) !== null;
}

/**
 * Chrome must visit the API before Google so the OAuth state cookie is set in
 * that browser. The WebView that requested the URL does not share Chrome's cookies.
 */
export function googleSignInBrowserUrl(apiBaseUrl: string, authorizationUrl: string): string {
  const proxy = new URL('/api/auth/expo-authorization-proxy', apiBaseUrl);
  proxy.searchParams.set('authorizationURL', authorizationUrl);
  return proxy.toString();
}

/** Session token from the app return URL. Prefers `session_token`, then the expo plugin's `cookie` param. */
export function sessionTokenFromAuthCallback(url: string): string | null {
  const parsed = parseAuthCallback(url);
  if (!parsed) return null;
  const direct = parsed.searchParams.get('session_token');
  if (direct) return direct;
  return sessionTokenFromSetCookie(parsed.searchParams.get('cookie'));
}

export function authErrorFromCallback(url: string): string | null {
  const parsed = parseAuthCallback(url);
  if (!parsed) return null;
  const error = parsed.searchParams.get('error');
  if (!error) return null;
  const text = error.replaceAll('_', ' ').trim();
  return text.length > 0 ? text : null;
}
